// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3DMwf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__B1cvM"};